import React from "react";
import { useParams } from "react-router-dom";
import { apiGetCustomerPublik } from "@/lib/publicApi";
import { rupiah, rencanaTeks } from "@/lib/format";
import { Loader2 } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import * as W from "@/lib/waktu";

const BAYAR = { BELUM_BAYAR: "Belum bayar", DP: "DP", LUNAS: "Lunas" };
const JENIS = { DIGITAL_PRINT: "Digital Printing", JERSEY: "Jersey", DTF: "DTF", CUSTOM: "Custom" };

// F1.5-H: "Cek Status Order dan Piutang" — the customer's own orders only.
export default function HalamanCustomer() {
  const { token } = useParams();
  const [d, setD] = React.useState(null);
  const [err, setErr] = React.useState(null);
  React.useEffect(() => { apiGetCustomerPublik(token).then(setD).catch((e) => setErr(e.response?.status === 404 ? "notfound" : "error")); }, [token]);
  if (err) return <div className="min-h-screen bg-white p-8 text-center text-slate-600">{err === "notfound" ? "Halaman tidak ditemukan atau link sudah tidak berlaku." : "Halaman tidak dapat dimuat. Coba lagi nanti."}</div>;
  if (!d) return <div className="min-h-screen bg-white p-8 text-center text-slate-500"><Loader2 className="inline animate-spin" /> Memuat…</div>;
  return (
    <div data-testid="halaman-customer" className="min-h-screen bg-slate-100 text-slate-900">
      <PublicHeader judul="Status order" sub={d.customer_nama} namaUsaha={d.nama_usaha} testid="customer-header" />
      <main className="relative -mt-8 mx-auto max-w-2xl px-4 pb-8 space-y-4">
        <div className="rounded-xl bg-white p-5 border-t-4 border-t-amber-500 shadow-[0_8px_24px_rgba(16,32,208,0.08)] text-center">
          <div className="text-[13px] font-semibold text-slate-500">Cek Status Order dan Piutang · Total sisa tagihan</div>
          <div data-testid="customer-piutang" className="mt-1 text-3xl font-bold text-soq-biru-tua tabular-nums">{rupiah(d.total_piutang)}</div>
          {d.total_piutang > 0 && d.rekening.length > 0 && <div className="mt-2 text-sm text-slate-600">Transfer ke: {d.rekening.map((r) => `${r.bank} ${r.nomor} a.n. ${r.atas_nama}`).join(" · ")}</div>}
        </div>
        {d.order.map((o) => (
          <div key={o.nomor_faktur} data-testid={`customer-order-${o.nomor_faktur}`} className={`rounded-xl bg-white p-4 shadow-sm border border-slate-800 space-y-1 text-sm ${o.sisa > 0 && !o.dibatalkan ? "border-l-4 border-l-amber-500" : ""}`}>
            <div className="flex justify-between"><span className="font-mono font-bold text-soq-biru-tua">{o.nomor_faktur}</span><span className="text-slate-500">{W.tanggal(o.tanggal)}</span></div>
            <div className="text-slate-600">{JENIS[o.jenis_transaksi] || o.jenis_transaksi}{!o.dibatalkan ? ` · rencana selesai ${rencanaTeks(o)}` : ""}</div>
            <div>Status: <b>{o.dibatalkan ? "Dibatalkan" : o.diserahkan ? (o.diserahkan === "DIKIRIM" ? "Sudah dikirim" : "Sudah diambil") : o.status_produksi}</b></div>
            <div className="flex justify-between"><span>Total {rupiah(o.total)} · {BAYAR[o.status_bayar]}</span><span className="font-semibold">Sisa {rupiah(o.sisa)}</span></div>
            {o.nota_url && <a href={o.nota_url} className="inline-flex min-h-[40px] items-center rounded-lg border-2 border-soq-biru px-3 text-sm font-semibold text-soq-biru">Lihat nota</a>}
          </div>
        ))}
        {d.order.length === 0 && <p className="text-center text-slate-500">Belum ada order.</p>}
      </main>
    </div>
  );
}
